import { FACILITY_ROLES } from "src/constants/facility";

export const ROLE_MAPPINGS = {
  CORP: {
    label: "Corporate Administrator",
    position: 5,
    id: FACILITY_ROLES.CORPORATE_ADMIN,
  },
  ADM: {
    label: "Administrator",
    position: 4,
    id: FACILITY_ROLES.ADMIN,
  },
  SFT: {
    label: "Staffing Coordinator",
    position: 3,
    id: FACILITY_ROLES.SHIFT_MANAGEMENT,
  },
  INV: {
    label: "Billing Manager",
    position: 2,
    id: FACILITY_ROLES.INVOICES,
  },
  DMT: {
    label: "Supervisor",
    position: 1,
    id: FACILITY_ROLES.DOCUMENTS,
  },
  REC: {
    label: "Recruiter",
    position: 0,
    id: FACILITY_ROLES.RECRUITMENT,
  },
};

export enum TAB_STATE {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum LOADING_STATE {
  ACTIVATE_OR_DEACTIVATE = "activate_or_deactivate",
  ADD_OR_EDIT = "add_or_edit",
}

export const NO_RESULTS_MESSAGE = "No users match your search.";

export enum PROCESS_MODAL_STATE {
  off = "off",
  edit = "edit",
  add = "add",
}

export const EXISTING_USER_WARNING =
  "A team member with this email address is already linked to another workplace. Do you want to link them to this workplace as well?";

const I18N_SKIP_TEAM_MEMBERS_ADD_READINESS_TEST_ID = "team-members-add-readiness";
const I18N_SKIP_TEAM_MEMBERS_ADD_READY_ATTRIBUTE = "data-team-members-add-ready";

export const TEAM_MEMBERS_ADD_READINESS_TEST_ID = I18N_SKIP_TEAM_MEMBERS_ADD_READINESS_TEST_ID;
export const TEAM_MEMBERS_ADD_READY_ATTRIBUTE = I18N_SKIP_TEAM_MEMBERS_ADD_READY_ATTRIBUTE;
